<template>
  <th class="clickable" @click="change_sort">
    <span class="pr-2" v-if="active"
      ><i class="fa fa-caret-down" v-if="ascending"></i><i class="fa fa-caret-up" v-else></i
    ></span>
    <slot></slot>
  </th>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import Lockr from 'lockr';

export default {
  props: ['value', 'sort_key'],
  data: function () {
    return {
      ascending: true,
      key: ''
    };
  },
  computed: {
    active() {
      return (
        this.value &&
        (this.value === this.sort_key ||
          this.value === '-' + this.sort_key ||
          this.value === '-' + this.sort_key.split(',').join(',-'))
      );
    }
  },
  methods: {
    change_sort() {
      if (this.active) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
      }

      let key = this.sort_key.split(',');
      let keys = (this.ascending ? '-' : '') + key.join(',' + (this.ascending ? '-' : ''));

      Lockr.set(this.key, {
        ascending: this.ascending,
        sort_key: this.sort_key,
        compiled: (this.ascending ? '-' : '') + this.sort_key
      });
      this.$emit('input', keys);
    },
    get_key() {
      return 'sort_' + window.location.pathname.split('/')[1];
    }
  },
  async mounted() {
    this.key = this.get_key();

    let existing_sort = Lockr.get(this.key);
    if (existing_sort && existing_sort.sort_key === this.sort_key) {
      this.ascending = existing_sort.ascending;
    }
  }
};
</script>

<style scoped></style>
